var App = App || {};

if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== "function") {
            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
        }

        var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP = function () {
            },
            fBound = function () {
                return fToBind.apply(this instanceof fNOP && oThis
                        ? this
                        : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
            };

        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();

        return fBound;
    };
}
$(function () {
    $('.tabs a').click(function (e) {
        $(window).trigger('resize');
    });
    $('.tab-map').on('shown.bs.tab', function (e) {
        $(window).trigger('map-set-zoom');
    });

    const hash = document.location.hash;
    if (hash) {
        $('.tabs a[href="' + hash + '"]').trigger('click');
    }

    let priceContainer = $('#scenario-price span'),
        promoCodeHintText = $('#promoCodeHintText'),
        successMessagePaid = $('#success-message-paid'),
        successMessageFree = $('#success-message-free'),
        submitButton = $('#scenarioForm form :submit');
    $(document).on('afterValidateAttribute', '#scenarioForm form', function (event, attribute, messages) {
        if (attribute.name === 'promoCodeCode') {
            $.get($(attribute.input).data('url'), {'code': attribute.value}, function (data) {
                priceContainer.html(data.fancyAmount);
                promoCodeHintText.html(data.hintText);

                if (data.amount) {
                    successMessagePaid.removeClass('d-none').show();
                    successMessageFree.hide();
                    submitButton.text(submitButton.data('paid'));
                } else {
                    successMessageFree.removeClass('d-none').show();
                    successMessagePaid.hide();
                    submitButton.text(submitButton.data('free'));
                }
            });
        }
    });

    $('#sidebar').stickySidebar({
        containerSelector: '.sidebar_container',
        innerWrapperSelector: '.sidebar_inner',
        topSpacing: 80,
        bottomSpacing: 80,
        minWidth: 1200
    });

    $('#items-filters').stickySidebar({
        containerSelector: '.sidebar_container',
        innerWrapperSelector: '.items-filters-inner',
        topSpacing: 80,
        bottomSpacing: 0,
        minWidth: 1200
    })

    $(document).on('click', '#promoCodeFieldLink', function (e) {
        e.preventDefault();
        let self = $(this);
        self.hide();
        $(self.attr('href')).removeClass('d-none').show();
    });

    $('.button-waypoint').waypoint(function (direction) {
        let target = $($(this.element).data('target'));
        if (direction === 'down') {
            target.addClass('fixed-bottom');
        } else {
            target.removeClass('fixed-bottom');
        }
    });

    let itemsList = $('#itemsList');
    let nextPageContentLoad = (url) => {
        $.ajax({
            url: url,
            headers: {'X-Pjax': true, 'X-Pjax-Container': '#itemsList'}
        }).done((data) => {
            itemsList.append(data)
            $(window).trigger('lazy.load');
            $(window).trigger('purchasedProductsUpdate');
            initPageScroll();
        });
    };
    let nextPageHandler = function (direction) {
        if (direction === 'down') {
            const button = $(this.element);
            let nextPage = button.attr('href');
            nextPageContentLoad(nextPage);
            button.parent().remove();
        }
    };
    let initPageScroll = () => {
        $('.next-items-page-button').waypoint(nextPageHandler, {offset: '100%'});
    }
    initPageScroll();
    $(document).on('click', '.next-items-page-button', function (e) {
        e.preventDefault();
        nextPageContentLoad($(e.target).attr('url'));
    });

    $(document).on('click', '.js-anchor', function (e) {
        e.preventDefault();
        const anchor = $(this).data("target"),
            navHeight = $('.header-wrap').outerHeight(),
            target = $(anchor);

        if (target.tab) {
            target.trigger('click');
        }
        if (target.length) {
            $('html,body').stop().animate({scrollTop: target.offset().top - navHeight}, 300);
        }
    });

    $('.city-select-link').on('click', function (e) {
        e.preventDefault();
        $('.city-top-widget-wrap .popup-menu-show').trigger('click');
    })

    $(function () {
        var imageLoadHandler = function (el) {
                el.next().fadeOut(500);
                el.removeClass('lazy');
            },
            beforeLoadHandler = function (el) {
                var preview = $('<img>').attr('src', el.attr('src'));
                preview.addClass('preview');
                preview.insertAfter(el);
            };

        $(window).on('lazy.load', function () {
            $('img.lazy').Lazy({
                beforeLoad: beforeLoadHandler,
                afterLoad: imageLoadHandler,
                onError: imageLoadHandler
            });
        });
        $(window).trigger('lazy.load');

        $('.video-container iframe, .lazy_youtube, .lazy_img').Lazy();
    });

    $(function () {
        $('.yandex-map').Lazy({
            visibleOnly: true,
            yaMapLoader: function (element) {
                new YaMap(element, element.data('options'));
            }
        });
    });

    $('.swiper.loading').each(function () {
        const container = $(this);
        const options = {
            'on': {
                'init': () => {
                    container.removeClass('loading');
                },
                'lock': () => {
                    container.addClass('lock');
                    container.removeClass('unlock');
                },
                'unlock': () => {
                    container.addClass('unlock');
                    container.removeClass('lock');
                }
            }
        };
        const swiper = new Swiper(this, jQuery.extend(options, container.data('options')));
    });

    let loginButton = $('button[data-target="#loginForm"]');
    if (loginButton.length > 0) {
        $(loginButton.data('target')).modal('show');
    }

    if (typeof window.authUrl !== 'undefined') {
        $.get(window.authUrl, function (data) {
            var cabinetLinks = $('.cabinet-link'),
                cabinetMenu = $('#cabinet-menu');
            if (data.isGuest === true) {
                cabinetMenu.data('disabled', true);
                cabinetLinks
                    .attr("data-bs-toggle", "modal")
                    .attr("data-bs-target", "#loginForm");
            } else {
                cabinetLinks.on('click', function (event) {
                    event.preventDefault();
                });
                var formName = $('#scenarioorderform-name');
                var formEmail = $('#scenarioorderform-email');
                if (!formName.val() && data.name) {
                    formName.val(data.name);
                }
                if (!formEmail.val() && data.email) {
                    formEmail.val(data.email);
                }
                $('.popup-lk-username').html(data.email);

                $.get(window.purchasedProductsUrl, function (data) {
                    window.purchasedProductsIds = data ?? [];
                    $(window).on('purchasedProductsUpdate', function () {
                        let btn = $('button[data-purchased-text]'),
                            productId = btn.data('purchased-id');
                        purchasedProductsIds.forEach((id) => {
                            $('.purchasedShow_' + id).removeClass('d-none')
                            if (productId === id) {
                                btn.html(btn.data('purchased-text'));
                            }

                        });
                    });
                    $(window).trigger('purchasedProductsUpdate');
                });
            }
        });
    }

    var clipboard = new ClipboardJS('.clipboard');
    clipboard.on('success', function (e) {
        const el = $(e.trigger);
        el.tooltip('show');
        setTimeout(() => {
            el.tooltip('hide');
        }, 5000);
    });

    $('.clipboard').tooltip({
        'title': 'Скопировано',
        'trigger': 'manual',
        'placement': 'bottom'
    }).on('click', (e) => e.preventDefault());

    $('.download-link').on('click', (e) => {
        const el = $(e.currentTarget);
        const link = document.createElement('a');
        link.download = el.data('name');
        link.href = el.data('link');
        link.click();
    });

    function initPlayerNow(container, originalFileUrl, hlsFileUrl, poster = null) {
        let options = {
            "playback": {
                "mp4": {
                    "url": originalFileUrl
                },
                "hls": {
                    "url": hlsFileUrl
                }
            },
            "lang": "ru",
            "logger": {
                "sentryDSN": "https://8bc71dfcbe19427e851fd22f6c1e69f4@sentry.cdnnow.ru/5",
                "sentryIgnoreErrors": [
                    "Error: Network Error",
                    "Error: Request failed with status code 403",
                    "Error: Request failed with status code 404",
                    "AbortError"
                ]
            },
            "viewers": {
                "serverUrl": "wss://counter.playernow.pro/ws"
            },
            "dvr": {
                "enabled": false,
                "duration": 0
            },
            "poster": poster,
            "showDebugPanel": false,
        };

        const id = container.attr('id') ?? 'playernow';
        container.data('playernow', new playernow(id, options));
        App.playerNow = container.data('playernow');
    }

    function playerNow(data, container) {
        if (data.preview) {
            var previewWrap = $('<div>'),
                preview = $('<img>')
            previewWrap.append(preview)

            preview.attr("src", data.preview);
            preview.addClass("player-preview-image")
            previewWrap.addClass("player-preview-wrap")
            container.before(previewWrap);
            container.hide();
        }

        if (data.preview) {
            previewWrap.on("click", function () {
                container.show();
                App.playerNow = container.data('playernow');
                App.playerNow.play();
                previewWrap.hide();
            });
        }
        initPlayerNow(container, data.originalfileurl, data.hlsfileurl, data.poster ?? null);
    }

    $.ajax({
        url: "https://cdn.playernow.ru/playernow.min.js",
        dataType: "script",
        timeout: 10 * 1000
    }).done(function () {
        $('#videoModal').on('show.bs.modal', function (e) {
            let data = $(e.relatedTarget).data();
            playerNow(data, $(e.relatedTarget));
        }).on('hidden.bs.modal', function (e) {
            App.playerNow.destroy();
        });

        $('.playernow').each(function () {
            var data = $(this).data();
            playerNow(data, $(this));
        });
    });

    $(document).on('shown.bs.modal', (e) => {
        let modal = $(e.target);
        let data = modal.data();
        if (typeof data.zindex !== 'undefined') {
            modal.css('z-index', data.zindex);
            // let bsModel = modal.data('bs.modal');
            // let backDrop = $(bsModel._backdrop);
            // backDrop.css('z-index', data.zindex - 1);
        }
    });

    $(document).on('submit', '.payment-method-form', function (e) {
        e.preventDefault();
        let form = $(e.target);
        let submitButton = $('button', form);
        submitButton.attr('disabled', true);

        $.post(form.attr('action'), form.serialize())
            .done(function (data) {
                if (data.success) {
                    window.location.href = data.redirectUrl;
                } else {
                    submitButton.attr('disabled', false);
                }
            }.bind(this))
            .fail(function (data) {
                submitButton.attr('disabled', false);
            }.bind(this))
            .always(function () {
            }.bind(this));
    })

    $(document).on('click', '.btn-tab', function () {
        const triggerTab = $(this).data('target');
        const tabInstance = new bootstrap.Tab(triggerTab)
        tabInstance.show()
    })

    let catalogSearch = document.querySelector('.catalog__search');
    if (catalogSearch !== null) {
        new CatalogSearch(catalogSearch);
    }
});
